export default __webpack_public_path__ + "static/media/ig.6d6d1c51.svg";